export const previousLocale = reactive({
    value: ''
})

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('i18n:beforeLocaleSwitch', ({ oldLocale }) => {
        previousLocale.value = oldLocale
    })
})
